import React from 'react';
import CommonComponent from '../CommonComponent';
import { appMethod as app } from '../../utils/app';

import './PageQrcode.less';

export class PageQrcode extends CommonComponent {
  ctx = null;

  constructor(props){
    super(props);

    this.state ={
      pageQRCodeShow: false,
      pageQRCodeData: {
        shareDialogShow: "100%",
        shareMenuShow: false
      },
      showShare: false
    }
  }

  componentDidMount(){
    this.getShareToMomentsSwitch();
    let drawcanvas = document.getElementById("pageqrcode-canvas");
    this.ctx = drawcanvas.getContext('2d');
  }

  show = (options) => {
    this.setData({
      pageQRCodeData: options.pageQRCodeData || {
        shareDialogShow: "100%",
        shareMenuShow: false
      }
    })
  } 

  drawing = () => {
    let _this = this;
    const ctx = this.ctx;
    _this.setDrawImage(ctx, _this.data.pageQRCodeData.goodsInfo.goods_img, 10, 10, 260, 260,1);
    _this.setDrawImage(ctx, _this.data.pageQRCodeData.goodsInfo.qrcode_img_url, 190, 280, 70, 70,0);
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, 280, 390);
    _this.setFillText(ctx, _this.data.pageQRCodeData.goodsInfo.text, '#333333',300);
  }

  setFillText = (ctx, text, color, y) => {
    let textString;
    if (text.length > 36){
      textString = text.substr(0,33) + '...';
    }else{
      textString = text;
    }
    let textRowArr = [];
    for (let tmp = 0; tmp < textString.length;) {
      textRowArr.push(textString.substr(tmp, 12))
      tmp += 12
    }
    for (let item of textRowArr) {
      ctx.font = "13px"
      ctx.fillStyle = color;
      ctx.fillText(item, 10, y);
      y += 20;

    }
    let goodsInfo = this.data.pageQRCodeData.goodsInfo;
    if (goodsInfo.isSeckill && goodsInfo.isSeckill == 1){
      goodsInfo.virtual_price = goodsInfo.price;
      goodsInfo.price = goodsInfo.seckill_price ? goodsInfo.seckill_price:'';
    }
    if (goodsInfo.price){
      ctx.font = "16px";
      ctx.fillStyle = '#FF3600';
      if (goodsInfo.integral == '2') {
        if (goodsInfo.price == '0.00') {
          ctx.fillText(goodsInfo.max_can_use_integral + '积分', 10, y+10)
        } else {
          ctx.fillText('¥' + goodsInfo.price + '+' + goodsInfo.max_can_use_integral + '积分', 10, y+10);
        }
      } else {
        ctx.fillText('¥' + goodsInfo.price, 10, y+10);
      }
    }
    let virtual_price = goodsInfo.virtual_price;
    if (virtual_price) {
      let vx = (String(goodsInfo.price).length + 1) * 9 + 20;
      ctx.font = "12px";
      ctx.fillStyle = '#999';
      ctx.fillText('¥' + virtual_price, vx , y + 10);
      ctx.beginPath();
      ctx.strokeStyle = '#999';
      ctx.moveTo(vx , y + 6);
      ctx.lineTo(vx + (String(virtual_price).length + 1) * 6 + 12, y + 6);
      ctx.stroke();
    }

    ctx.font = "10px"
    ctx.fillStyle = '#666666';
    ctx.fillText('长按识别二维码',190,365)

    ctx.beginPath()
    ctx.lineWidth = 1;
    ctx.lineJoin = 'miter';
    ctx.moveTo(260, 280)
    ctx.lineTo(270, 280)
    ctx.lineTo(270, 290)

    ctx.moveTo(260, 375)
    ctx.lineTo(270, 375)
    ctx.lineTo(270, 365)

    ctx.moveTo(190, 280)
    ctx.lineTo(180, 280)
    ctx.lineTo(180, 290)

    ctx.moveTo(190, 375)
    ctx.lineTo(180, 375)
    ctx.lineTo(180, 365)

    ctx.strokeStyle = '#FF3600';
    ctx.stroke()

  }

  setDrawImage = (ctx,src,x,y,w,h,index) => {
    let _this = this;
    let img = new Image();

    img.setAttribute('crossOrigin', 'anonymous');
    img.onload = function(){
      ctx.drawImage( img , x, y, w, h);
      if (index == 1 && _this.data.pageQRCodeData.goodsInfo.isSeckill){
        _this.setDrawImage(ctx, 'http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/seckill-share-icon.png', 10, 252, 62, 18,0);
      }
    }
    img.src = src;
  }

  // 获取是否显示转发朋友圈
  getShareToMomentsSwitch = () => {
    let that = this;
    app.sendRequest({
      url: '/index.php?r=AppData/GetShareToMomentsSwitch',
      data: {
      },
      success: function (res) {
        that.setData({
          showShare: res.data
        });
      }
    });
  }

  // 这里是一个自定义方法
  // 隐藏分享组件
  hideShareDialog = () => {
    this.setData({
      "pageQRCodeData.shareDialogShow": "100%",
      "pageQRCodeData.shareMenuShow": false,
      "pageQRCodeShow": false
    })
  }

  showAppMessageMenu = () => {
    let pageInstance = app.getAppCurrentPage();
    pageInstance.shareClickEvent();
    this.hideShareDialog();
  }

  // 转发到朋友圈
  showPageCode = () => {
    this.setData({
      "pageQRCodeData.shareMenuShow": false,
      pageQRCodeShow: true
    });
    setTimeout(() => {
      this.drawing();
    }, 200);
  }

  stopPropagation = (event) => {
    event.stopPropagation();
  }

  savePageCode = () => {
    let drawcanvas = document.getElementById("pageqrcode-canvas");
    let img = drawcanvas.toDataURL("image/png").replace("image/png", "image/octet-stream");

    var link = document.createElement('a');
    link.setAttribute('download', 'code.png');
    link.setAttribute('href', img);
    link.click();

    setTimeout(() => {
      app.showToast({
        title: '保存成功',
        duration: 4000
      });
      this.setData({
        "pageQRCodeData.shareDialogShow": "100%",
        "pageQRCodeData.shareMenuShow": false,
        "pageQRCodeShow": false
      })
    }, 2000);
    
  }

  render(){
    let {
      pageQRCodeData,
      pageQRCodeShow,
      showShare
    } = this.state;
    return (
      <div className="common-component page-qrcode page-qr-code-dialog" onClick={this.hideShareDialog} onTouchMove={this.stopPropagation} style={{top: pageQRCodeData.shareDialogShow}}>
        <div className="page-qr-code" hidden={ !pageQRCodeShow } onClick={this.stopPropagation}>
          <canvas id="pageqrcode-canvas" className="goods-share-canvas" width="280" height="390"></canvas>
          <div className="save-btn" onClick={this.savePageCode}>保存图片</div>
        </div>
        <div className="page-bottom-dialog" style={{position: 'absolute', bottom: pageQRCodeData.shareMenuShow ? 0 : '-3.2rem', left: 0, width: '7.50rem', backgroundColor: 'rgba(238, 238, 238, 1)'}} onClick={this.stopPropagation}>
          <button className="button" onClick={this.showAppMessageMenu}>转发至好友</button>
          { showShare && <button className="button shareToMoments" onClick={this.showPageCode}>转发至朋友圈</button> }
          <button className="button cancelShare" onClick={this.hideShareDialog}>取消</button>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/common/page-qrcode/PageQrcode.jsx